import { OmnisearchSuggestion, SearchModel } from '@fullstory/search-model';
import { TimeRange } from '@fullstory/client-api';

export type SearchUIMode = 'segment' | 'metric' | 'funnel' | 'heatmap';

export enum SearchActionTypes {
  SetTimeRange = 'search.setTimeRange',
  AddRow = 'search.addRow',
  ReplaceOrAddUserRow = 'search.replaceOrAddUserRow',
  AppendDependents = 'search.appendDependents',
  SetInSameSession = 'search.setInSameSession',
  SetPlatform = 'search.setPlatform',
  SetModel = 'search.setModel',
  SetPendingSuggestion = 'search.setPendingSuggestion',
  ClearPendingSuggestion = 'search.clearPendingSuggestion',
}

export type SearchState = {
  timeRange: TimeRange;
  uiModel: SearchModel;
  searchModel: SearchModel;
  // NB: in an ideal world, we would:
  // a.) create an unnamed segment url that includes the suggestion and navigate to that url, or
  // b.) update the search ui model with the suggestion directly via a redux action
  //
  // But neither of those work in this case.  We can't do a.) because SegmentDefinition does not
  // support partially filled criteria, which omnibox requires.  And b.) doesn't work because
  // the search ui takes the url as the source of truth on navigate and overwrites the state updates
  // from the suggestion.
  //
  // So instead, we put a pending suggestion in redux alongside the model itself.  When the search ui
  // loads, we update the search model with any pending suggestions, and then clear the pending
  // suggestions.
  pendingSuggestion: {
    suggestion: OmnisearchSuggestion;
    mode: SearchUIMode;
  } | null;
};
